var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c("div", { staticClass: "d-flex gap-5" }, [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.dateSubSubtractingValue"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Subtract Value or pick from a variable",
              "show-attributes": true,
              "show-emoji": false,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.sub.value,
              callback: function ($$v) {
                _vm.$set(_vm.clone.sub, "value", $$v)
              },
              expression: "clone.sub.value",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.dateSubSubtractingUnitType"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: { items: _vm.unitTypes, idKey: "id", labelKey: "label" },
            model: {
              value: _vm.clone.sub.unit,
              callback: function ($$v) {
                _vm.$set(_vm.clone.sub, "unit", $$v)
              },
              expression: "clone.sub.unit",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.sub.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.sub, "fromFormat", $$v)
            },
            expression: "clone.sub.fromFormat",
          },
        }),
        _vm._v(" "),
        _c("FormatPickerInput", {
          attrs: { title: "To Format" },
          model: {
            value: _vm.clone.sub.toFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.sub, "toFormat", $$v)
            },
            expression: "clone.sub.toFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.sub.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.sub, "fromLocale", $$v)
            },
            expression: "clone.sub.fromLocale",
          },
        }),
        _vm._v(" "),
        _c("LocalePickerInput", {
          attrs: { title: "To Locale" },
          model: {
            value: _vm.clone.sub.toLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.sub, "toLocale", $$v)
            },
            expression: "clone.sub.toLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }